import React from "react";

import "./style.scss";

const Title = ({title, children}) => (
    <h2 className="section-title" data-aos="fade-up">{title} {children}</h2>
)

export default Title
